module.exports = __webpack_public_path__ + "img/add-pet-step2.b7a190fa.jpg";